import { Modal } from 'antd';

type Props = {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const DurationChangeModal = ({ open, onConfirm, onCancel }: Props) => {
  return (
    <Modal
      title="Attention : This change will impact time slots"
      open={open}
      onCancel={onCancel}
      onOk={onConfirm}
      okText="Confirm"
      cancelText="Cancel"
      closable={true}
      width={620}
    >
      <div>
        <p>
          Changing the experience duration will impact the hotel's Extranet
          schedule.
        </p>
        <br />
        <p>
          The end time of all existing and future time slots will be
          automatically updated to match the new duration.
        </p>
        <br />
        <p>
          Please review the Extranet schedule afterward to ensure all time slots
          are still correct.
        </p>
      </div>
    </Modal>
  );
};
